



































































































import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import {
  groupTrendSynthEZAvgScore,
  getClassList
} from '@/api/teachingProtection/assessment'
import MiniTable from '../../_components/MiniTable.vue'
import AvgLine from '../../_components/charts/AvgLine.vue'
@Component({
  components: {
    MiniTable,
    AvgLine
  }
})
export default class extends Vue {
  private frirstChartData: any = {};
  private barDataArray: Array<object> = [];

  private mainArr = [];
  private subArr = [];
  private classroomName: any = '';
  private sexName: any = '';
  private compareName: any = '';
  private tabPosition: any = '';
  private classNames: any = [];
  private info: any = {};
  private tabList: any = [
    {
      name: ' 趋势 ',
      code: 1
    },
    {
      name: '详细数据',
      code: 2
    }
  ];

  private params: any = {};
  created() {
    if (!(this as any).$route.query.searchParams) return
    this.params = JSON.parse((this as any).$route.query.searchParams as string)
    localStorage.setItem('searchParams', JSON.stringify(this.params))
    const params = JSON.parse(
      (this as any).$route.query.searchParams as string
    )
    const classroomNames: any = []
    const sexNames: any = []
    const compareNames: any = []

    getClassList({
      periodType: this.params.periodType,
      year: params.year,
      semesterType: params.semesterType
    }).then((res: any) => {
      res.data.array.map((v: any) => {
        v.classrooms.map((q: any) => {
          if (this.params.classroomIds.indexOf(q.id) !== -1) {
            classroomNames.push(q.name)
          }
        })
      })
      this.classroomName = classroomNames.join('、')
    })
    this.$enums.gender.map((v: any) => {
      if (this.params.sexes.indexOf(v.code) !== -1) {
        sexNames.push(v.description)
      }
    })
    this.sexName = sexNames.join('、')
    this.$enums.classroomTypes.map((v: any) => {
      if (this.params.compareIds.indexOf(v.code) !== -1) {
        compareNames.push(v.description)
        this.classNames.push({
          name: v.description,
          code: v.code
        })
      }
    })
    this.compareName = compareNames.join('、')
    // if (!(this.params.classroomIds.length > 0)) {
    //   this.tabPosition = this.classNames[0].code;
    // }
    this.tabPosition = 1
    groupTrendSynthEZAvgScore(this.params).then((res) => {
      if (res.data.synthEZAvgScore) {
        res.data.synthEZAvgScore.details.map((item: any) => {
          item.values.pop()
          item.valueDescs.pop()
        })
      }
      this.info = res.data
      this.frirstChartData = res.data.synthEZAvgScore
      this.barDataArray =
        res.data.barChart.map((item: any) => {
          item.details.map((_item: any) => {
            _item.values.pop()
            _item.valueDescs.pop()
          })
          return item
        }) || [];
      (this as any).mainArr = this.barDataArray.slice(0, 5);
      (this as any).subArr = this.barDataArray.slice(5, 8)
    })
  }
  tabChange(tab: any) {
    this.params.compareIds = [this.classNames[0].code]
    groupTrendSynthEZAvgScore(this.params).then((res) => {
      if (res.data.synthEZAvgScore) {
        res.data.synthEZAvgScore.details.map((item: any) => {
          item.values.pop()
          item.valueDescs.pop()
        })
      }
      this.frirstChartData = res.data.synthEZAvgScore
      if (res.data.barChart) {
        this.barDataArray =
          res.data.barChart.map((item: any) => {
            item.details.map((_item: any) => {
              _item.values.pop()
              _item.valueDescs.pop()
            })
            return item
          }) || []
      }

      (this as any).mainArr = this.barDataArray.slice(0, 5);
      (this as any).subArr = this.barDataArray.slice(5, 8)
    })
  }
}
